import { render, staticRenderFns } from "./Slideover.vue?vue&type=template&id=08058a26"
import script from "./Slideover.vue?vue&type=script&lang=js"
export * from "./Slideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports